import { render } from "./LogiN.vue?vue&type=template&id=1d4866ad"
import script from "./LogiN.vue?vue&type=script&lang=js"
export * from "./LogiN.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__